<template>
  <div class="pages-preview">
    <iframe
      v-if="type == 1"
      class="doc"
      :src="`https://view.officeapps.live.com/op/view.aspx?src=${url}`"
      frameborder="0"
    ></iframe>
    <iframe
      v-if="type == 2"
      class="doc"
      :src="`https://www.whtlkj.net/pdfjs/web/viewer.html?file=${url}`"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'TeacherResource',
  data: () => ({
    type: 0, // 1其他  2pdf
    url: '',
  }),

  mounted() {
    console.log('query', this.$route.query)
    let url = this.$route.query.url
    let type = 1
    if (url.indexOf('PDF') !== -1 || url.indexOf('pdf') !== -1) {
      type = 2
    }
    console.log('type', type)
    this.type = type
    this.url = url
  },
  methods: {},
}
</script>

<style lang="less" scoped>
.pages-preview {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: #fff;
  .doc {
    width: 100vw;
    height: 100vh;
  }
}
</style>
